import React from 'react';
import PropTypes from 'prop-types';
import {setCookie, isEqualId, formatId} from "../utilities";

const GradeSelector = ({
                         open,
                         gradeInfo,
                         currentGradeId,
                         changeGrade,
                         openGradeSelector,
                         closeGradeSelector,
                         contentHeight,
                         currentBodyTypeId,
                       }) => {
  
  // エンジン一覧
  let fuelArr = [];
  let i, max;
  for (i = 0, max = gradeInfo.length; i < max; i = i + 1) {
    const grade = gradeInfo[i];
    let flg = true;
    let j, max2;
    for (j = 0, max2 = fuelArr.length; j < max2; j = j + 1) {
      if (grade.fuel === fuelArr[j]) {
        flg = false;
        break;
      }
    }
    if (flg) fuelArr.push(grade.fuel);
  }
  
  const getGradeName = (gradeInfo)=> {
    if (gradeInfo.specialCar === true) {
      return gradeInfo.gradeId;
    } else {
      return (gradeInfo.gradeName && gradeInfo.gradeName !== '') ? gradeInfo.gradeName : gradeInfo.gradeId;
    }
  };
  
  return (
    <div className={'ExteriorView__grade-selector' + ((open === true) ? ' open': '')}>
      <div className="ExteriorView__grade-selector__container">
        {gradeInfo.map((grade, index) => {
          // if (currentGradeId === grade.gradeId) {
          if (isEqualId(currentGradeId, grade.gradeId)) {
            return (
              <a className={'ExteriorView__grade-selector__link-current' + ((open === true) ? ' open': '')}
                 href="javascript:void(0)"
                 onClick={(e) => {
                   e.preventDefault();
                   if (open === true) {
                     if (closeGradeSelector) closeGradeSelector();
                   } else {
                     if (openGradeSelector) openGradeSelector();
                   }
                 }}
                 key={index}
              >
                {getGradeName(grade)}
              </a>
            )
          } else {
            return null;
          }
        })}
      </div>
      <div className="ExteriorView__grade-selector__container2">
        <div className="ExteriorView__grade-selector__container3">
          <a className="ExteriorView__grade-selector__link-close"
            href="javascript:void(0)"
            onClick={(e)=> {
            e.preventDefault();
            //
            if (closeGradeSelector) closeGradeSelector();
          }}
          >CLOSE</a>
          <ul className={'ExteriorView__grade-selector__list-ul' + ((3 <= fuelArr.length) ? ' single-line' : '')}>
            {fuelArr.map((fuel, index) => {
              return (
                <li key={index}>
                  <dl className="ExteriorView__grade-selector__list-dl">
                    <dt>{fuel}</dt>
                    {gradeInfo.map((grade, index) => {
                      if (fuel === grade.fuel) {
                        return (
                          <dd key={index}>
                            <a
                              // className={'ExteriorView__grade-selector__link' + ((currentGradeId === grade.gradeId) ? ' current': '')}
                              className={'ExteriorView__grade-selector__link' + (isEqualId(currentGradeId, grade.gradeId) ? ' current': '')}
                              href={'#' + grade.gradeId}
                              onClick={(e) => {
                                e.preventDefault();
                                if (closeGradeSelector) closeGradeSelector();
                                if (changeGrade) {
                                  changeGrade(grade.gradeId);
  
                                  // ブロックのCookieに保存
                                  setCookie('mj_360bt', formatId(currentBodyTypeId));
                                  setCookie('mj_360gr', formatId(grade.gradeId));
                                  
                                }
                              }}
                            >
                              {getGradeName(grade)}
                            </a>
                          </dd>
                        )
                      } else {
                        return null;
                      }
                    })}
                  </dl>
                </li>
              )
            })}
          </ul>
        </div>
      </div>
    </div>
  )
};
GradeSelector.propTypes = {
  gradeInfo: PropTypes.arrayOf(
    PropTypes.shape({
      gradeId: PropTypes.string,
      fuel: PropTypes.string,
    }),
  ),
  currentGradeId: PropTypes.string,
  changeGrade: PropTypes.func,
};
GradeSelector.defaultProps = {
  gradeInfo: null,
  currentGradeId: null,
  changeGrade: null,
};

export default GradeSelector;



// WEBPACK FOOTER //
// ./src/containers/exterior-view/GradeSelector.jsx